export const ShopOptionsAvailable = {
    newYearsMenuSoldOut: 'newYearsMenuSoldOut',
    paymentOptions: 'paymentOptions',
    temporarilyClosedOptions: 'temporarilyClosedOptions',
    enabledSubscriptionServices: 'enabledSubscriptionServices',
    deliveryMethods: 'deliveryMethods',
    deliveryMethodsChannelPosition: 'deliveryMethodsChannelPosition',
    onlinePosHQ: 'onlinePosHQ',
    tableServing: 'tableServing',
    extraInfoBoxes: 'extraInfoBoxes',
    isShopHidden: 'isShopHidden',
    scannerEnabled: 'scannerEnabled',
    newAddonsDesign: 'newAddonsDesign',
    enableMysteryBox: 'enableMysteryBox',
    enableMysteryBoxRandomActOfKindness: 'enableMysteryBoxRandomActOfKindness',
    enableNewBasketPage: 'enableNewBasketPage',
    enableRefillDrinkMessage: 'enableRefillDrinkMessage',
    vat: 'vat',
    driveInDeliveryEnabled: 'driveInDeliveryEnabled',
    recommendationEngineEnabled: 'recommendationEngineEnabled',
    recommendationEngineEnabledCarousel: 'recommendationEngineEnabledCarousel',
    recommendationEngineEnabledCarouselDesktop: 'recommendationEngineEnabledCarouselDesktop',
    recommendationEngineEnabledBasket: 'recommendationEngineEnabledBasket',
    recommendationEngineEnabledCatalog: 'recommendationEngineEnabledCatalog',
    recommendationEngineEnabledMarketingCard: 'recommendationEngineEnabledMarketingCard',
    enableBeeperDeviceFeature: 'enableBeeperDeviceFeature',
    hotjarTracking: 'hotjarTracking',
    isSecretRestaurant: 'isSecretRestaurant',
    sortingByRecommendationEngineEnabled: 'sortingByRecommendationEngineEnabled',
    unpaidDriveThrough: 'unpaidDriveThrough',
    releaseTrigger: 'releaseTrigger',
    enableLeftMenuWithNewBasketDesignWithoutMarketingCards: 'enableLeftMenuWithNewBasketDesignWithoutMarketingCards',
    enableSendingPreparedProductForDriveThrough: 'enableSendingPreparedProductForDriveThrough',
    enableSendingEmptyProduct: 'enableSendingEmptyProduct',
    shopManagerControlsBusinessHours: 'shopManagerControlsBusinessHours',
    enableSingleLaneDriveThrough: 'enableSingleLaneDriveThrough',
    enableDualLaneDriveThrough: 'enableDualLaneDriveThrough',
    dmiStationData: 'dmiStationData',
    userTrackingId: 'userTrackingId',
};
export const WeekdayToTimeBoxWeekday = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7,
};
export const ShopAvailabilityStatus = {
    STILL_NOT_OPEN: 'Still not open',
    CLOSED: 'Closed already',
    OPEN_NOW: 'Open now',
};
